import { useEffect } from "react";

import { useTranslation } from "react-i18next";
import { useLocation } from "react-router-dom";

import { useGetAuthenticatedUserUserGetQuery } from "api";
import { getUserPermission, isAllowed } from "authorization/authorization.util";
import { ZoneUserRole } from "constants/userContstants";
import { useNavigate } from "hooks/useNavigate";
import { setLanguage } from "utils/localStorage";

export const useAuthenticatedUser = () => {
  const navigate = useNavigate();
  const { i18n } = useTranslation();
  const location = useLocation();

  const {
    data: userData,
    isLoading,
    isFetching,
    isError,
  } = useGetAuthenticatedUserUserGetQuery(undefined, {
    refetchOnFocus: true,
  });

  const user = userData?.data;

  useEffect(() => {
    if (isLoading) return;
    if (user && !isError) {
      const language = user.preferences?.language;

      if (language && language !== i18n.language) {
        setLanguage(language);
        i18n.changeLanguage(language);
      }

      const isPathToDashboard = location.pathname.includes("monitor/overview");
      const isAllowedToViewDashboard = isAllowed(user, [
        ZoneUserRole.DATA_READER,
        ZoneUserRole.DATA_READER_LIMITED,
        ZoneUserRole.SERVICE_MONITOR,
      ]);
      if (isPathToDashboard && !isAllowedToViewDashboard) {
        navigate("/administration");
      }
    }
  }, [user, i18n, location.pathname, navigate, isLoading, isError]);

  return {
    authUser: user,
    isLoading,
    isFetching,
    isError,
    permissions: getUserPermission(user),
  };
};
